import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { StoreGatewayService } from '../../services/gateway/store.gateway.service';
import * as StoreActions from './store-actions';

@Injectable()
export class StoreEffects {
  constructor(private actions$: Actions, private storesGateway: StoreGatewayService) {}

  loadStores$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StoreActions.loadStores),
      mergeMap(() =>
        this.storesGateway.list().pipe(
          map((stores) => StoreActions.loadStoresSuccess({ stores })),
          catchError((error) => of(StoreActions.loadStoresFailure({ error: error.message })))
        )
      )
    )
  );
}
